/* Benpuz · piezas finales — JS vanilla, sin librerías.
   Del export aprobado (diseno/claude-design/export/piezas.js), sin tocar.
   Sube al tema como assets/benpuz-piezas.js y lo cargan solo las plantillas
   que lo usan: prosa, FAQ, contacto y carrito. El footer no lleva JS.

   `pendientes()` se llama SIEMPRE sobre el contenedor `.pr`, nunca sobre
   document.body: si corre sobre el documento entero también marca el
   ⟦diseñador⟧ del cajetín del footer, que es una casilla fija y no un dato
   pendiente del texto. */
window.bp = {
  /* FAQ: pliega pares <h3> + contenido consecutivo. Sin marcado especial.
     Si no hay JS, todo queda abierto y legible. */
  faq: function (root) {
    Array.prototype.forEach.call(root.querySelectorAll('.faq h3'), function (h) {
      var cuerpo = document.createElement('div');
      cuerpo.className = 'faq-b';
      var n = h.nextElementSibling;
      while (n && n.tagName !== 'H3' && n.tagName !== 'H2') {
        var sig = n.nextElementSibling;
        cuerpo.appendChild(n);
        n = sig;
      }
      h.parentNode.insertBefore(cuerpo, h.nextSibling);
      cuerpo.hidden = true;
      var et = document.createElement('span');
      et.className = 'faq-e';
      et.textContent = 'ABRIR';
      h.appendChild(et);
      h.setAttribute('role', 'button');
      h.setAttribute('tabindex', '0');
      h.setAttribute('aria-expanded', 'false');
      function alterna() {
        var abre = cuerpo.hidden;
        cuerpo.hidden = !abre;
        h.setAttribute('aria-expanded', String(abre));
        et.textContent = abre ? 'CERRAR' : 'ABRIR';
        h.className = abre ? 'on' : '';
      }
      h.addEventListener('click', alterna);
      h.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); alterna(); }
      });
    });
  },
  /* Marca los datos pendientes escritos entre corchetes dobles dentro del texto. */
  pendientes: function (root) {
    var re = /\u27E6[^\u27E7]*\u27E7/;
    var t = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodos = [], n;
    while ((n = t.nextNode())) { if (re.test(n.nodeValue)) nodos.push(n); }
    nodos.forEach(function (nodo) {
      var partes = nodo.nodeValue.split(/(\u27E6[^\u27E7]*\u27E7)/);
      var frag = document.createDocumentFragment();
      partes.forEach(function (p) {
        if (!p) return;
        if (re.test(p)) {
          var s = document.createElement('span');
          s.className = 'pd';
          s.textContent = p;
          frag.appendChild(s);
        } else { frag.appendChild(document.createTextNode(p)); }
      });
      nodo.parentNode.replaceChild(frag, nodo);
    });
  },
  /* Carrito: cantidad por línea, total de línea y subtotal. */
  carrito: function (root) {
    function clp(n) { return '$' + n.toLocaleString('es-CL'); }
    function suma() {
      var s = 0;
      Array.prototype.forEach.call(root.querySelectorAll('[data-linea]'), function (l) {
        var precio = +l.getAttribute('data-precio');
        var cant = +l.querySelector('[data-cant]').textContent;
        s += precio * cant;
        l.querySelector('[data-total]').textContent = clp(precio * cant);
      });
      root.querySelector('[data-subtotal]').textContent = clp(s);
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-paso]'), function (b) {
      b.addEventListener('click', function () {
        var l = b.closest('[data-linea]');
        var c = l.querySelector('[data-cant]');
        var v = +c.textContent + (+b.getAttribute('data-paso'));
        if (v < 1) v = 1;
        if (v > 99) v = 99;
        c.textContent = v;
        suma();
      });
    });
    suma();
  }
};
